import React, {useState} from 'react';
import {SegmentationLegend} from '../../../types/model/Model';
import {Box, Typography} from '@material-ui/core';
import RoundButton from '../../../base-components/StudioButton/RoundButton';

interface ISegmentaionLegendProps {
  legends: SegmentationLegend[];
  placement?: 'column' | 'row';
}

const SegmentationLegendView = ({legends, placement}: ISegmentaionLegendProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  return legends.length > 0 ? (
    <div className="legends__view">
      {legends.length > itemsPerPage && (
        <div>
          <RoundButton
            buttonIcon="chevronLeft"
            buttonRole="naked-light"
            size="small"
            customClass="pagination_left_button"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          />
        </div>
      )}
      <div className={`legends__view__container ${placement === 'row' ? 'row' : ''}`}>
        {legends.slice(indexOfFirstItem, indexOfLastItem).map(({r, g, b, name}) => (
          <Box className="legends__view__single__legend">
            <Box
              className="legends__view__single__legend__box"
              style={{backgroundColor: `rgb(${r} ${g} ${b})`}}
            ></Box>
            <Typography className="legends__view__single__legend__title">
              {name}
            </Typography>
          </Box>
        ))}
      </div>
      {legends.length > itemsPerPage && (
        <div>
          <RoundButton
            buttonIcon="chevronRight"
            buttonRole="naked-light"
            size="small"
            customClass="pagination_right_button"
            disabled={indexOfLastItem >= Object.entries(legends).length}
            onClick={() => setCurrentPage(currentPage + 1)}
          />
        </div>
      )}
    </div>
  ) : null;
};

export default SegmentationLegendView;
